import React from 'react';

export type ExpandIconProps = {
  /**  isExpand set to "true" or "false"  */
  isExpand?: boolean;
  /** change icon color if Accordion theme is theme-dark-accnt-bg */
  isDarkTheme?: boolean;
};

export function ExpandIcon({
  isExpand = false,
  isDarkTheme = false,
  ...props
}: ExpandIconProps) {
  return (
    <>
      <i
        {...props}
        className={`expand-icon ${
          isDarkTheme ? 'icon-chevron-white' : 'icon-chevron'
        } animate mar-l-sm-all font-bold type-lg ${
          isExpand ? 'rotate270-after' : 'rotate90-after'
        }`}
      />
      <style jsx>{`
        @media (min-width: 1025px) {
          .expand-icon:after {
            height: 20px;
            width: 20px;
            top: 1px;
          }
        }
      `}</style>
    </>
  );
}
